import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const EditorConversionModal: LoadableType<{}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EditorConversionModal" */ '../src/EditorConversionNotification/EditorConversionModal.tsx'
			)
		).EditorConversionModal,
	name: 'EditorConversionModal',
});
